/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outdatedbrowser_Updatenow2Inputs */

const en_outdatedbrowser_updatenow2 = /** @type {(inputs: Outdatedbrowser_Updatenow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update now`)
};

/**
* | output |
* | --- |
* | "Update now" |
*
* @param {Outdatedbrowser_Updatenow2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const outdatedbrowser_updatenow2 = /** @type {((inputs?: Outdatedbrowser_Updatenow2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outdatedbrowser_Updatenow2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_outdatedbrowser_updatenow2(inputs)
});
export { outdatedbrowser_updatenow2 as "outdatedBrowser_updateNow" }